import { QueryStatus } from "@tanstack/react-query";

import { AlertsQueries } from "@/queries/AlertsQueries.ts";
import { AuthQueries } from "@/queries/AuthQueries.ts";
import { BillingQueries } from "@/queries/BillingQueries.ts";
import { ConditionQueries } from "@/queries/ConditionQueries.ts";
import { DiabetesQueries } from "@/queries/DiabetesQueries.ts";
import { MailPreferenceQueries } from "@/queries/MailPreferenceQueries.ts";
import { MessagingQueries } from "@/queries/MessagingQueries.ts";
import { NotesQueries } from "@/queries/NotesQueries.ts";
import { ObservationsQueries } from "@/queries/ObservationsQueries.ts";
import { PatientSyncQueries } from "@/queries/PatientSyncQueries.ts";
import { PractitionerQueries } from "@/queries/PractitionerQueries.ts";
import { PrescriptionQueries } from "@/queries/PrescriptionQueries.ts";
import { UserQueries } from "@/queries/UserQueries.ts";

import { ConfigQueries } from "./ConfigQueries";
import { QaQueries } from "./QaQueries";

////////////////////////////////////////
////             Helpers            ////
////////////////////////////////////////

const practitioner = new PractitionerQueries();

/**
 * Singleton class that contains all queries
 */
export const Queries = {
  alerts: new AlertsQueries(practitioner),
  auth: new AuthQueries(),
  observations: new ObservationsQueries(practitioner),
  practitioner,
  user: new UserQueries(),
  diabetes: new DiabetesQueries(),
  messaging: new MessagingQueries(practitioner),
  prescription: new PrescriptionQueries(),
  mailPreference: new MailPreferenceQueries(),
  condition: new ConditionQueries(),
  qa: new QaQueries(),
  notes: new NotesQueries(),
  billing: new BillingQueries(),
  config: new ConfigQueries(),
  patientSync: new PatientSyncQueries(practitioner),
};

export type Status = QueryStatus | "idle";
